/**
 * Diese Komponente bindet dann das jeweilige Modul ein, lädt die Seiten und übergibt den User, sowie die verfügbaren Socialmediakanäle und die jeweiligen Pfade und Token.
 */

import 'regenerator-runtime/runtime'
import React from 'react'
import { Provider, useSelector } from 'react-redux'

import { Theme } from '@mui/material'
import { SocialNetworkLicensePermissions } from '@professocial/professocialTypes/types/commonTypes'
import { getLicensePermissions, getTheme, getUser } from '../../../../store/common/common.selectors'
import { UserSettings } from '@professocialApi/professocial-core-frontend-api'
import { PostingScreen } from '@professocial/professocialPosting/src/shared/types/types'
import ProfessocialPosting from '@professocial/professocialPosting/src/screens/ProfessocialPosting'
import createSagaMiddleware from 'redux-saga'
import { applyMiddleware, createStore } from 'redux'
import { postingRootReducer } from '@professocial/professocialPosting/src/store/postingRoot.reducer'
import { composeWithDevTools } from '@redux-devtools/extension'
import { postingRootSagas } from '@professocial/professocialPosting/src/store/postingRoot.sagas'

const sagaMiddleware = createSagaMiddleware()
const storePosting = createStore(
  postingRootReducer,
  composeWithDevTools(
    applyMiddleware(sagaMiddleware),
  ),
)
sagaMiddleware.run(postingRootSagas)

const EditorDashboardPosting: React.FC = () => {
  const user: UserSettings | undefined = useSelector(getUser)
  const theme: Theme = useSelector(getTheme)
  const licensePermissions: SocialNetworkLicensePermissions = useSelector(getLicensePermissions)

  return (
    <Provider store={storePosting}>
      <ProfessocialPosting
        postingConfiguration={{
          generalPostingOptions: {
            allowLinkParsing: true,
            allowTemplateEdit: true,
            showAsPopUp: false,
            showPreview: true,
            useMediaGallery: true,
            showLinkIndividualisation: true,
            showIndividualHashtags: true,
            allowLinkIndividualisation: true,
            allowIndividualHashtags: true,
            allowTags: true,
            templateSelection: true,
            allowImageUpload: true,
            allowVideoUpload: true,
          },
          user,
          theme,
          licensePermissions: licensePermissions,
        }}
        postingScreen={PostingScreen.MAIN}
      />
    </Provider>
  )
}
export default EditorDashboardPosting
